export var grey = {
    900: '#212121',
    800: '#424242',
    700: '#616161',
    600: '#757575',
    500: '#949494',
    400: '#BDBDBD',
    350: '#D3D3D3',
    300: '#E0E0E0',
    250: '#E3E3E3',
    200: '#EEEEEE',
    100: '#F5F5F5',
    50: '#FAFAFA',
    0: '#FFFFFF',
};
//# sourceMappingURL=grey.js.map